export const FLAG_COHORT_MAX_FLAGS_PER_REQUEST = 20

const RECORDABLE_FLAG_NAME = /^[A-Za-z0-9._~-]{1,100}$/

export const buildFlagCohortsContextValue = (flagCohorts) => {
  const names = Object.keys(flagCohorts || {}).sort()
  return names.length ? `,${names.join(',')},` : ','
}

export const isInFlagCohort = (flagCohorts, flagName) => {
  return Object.prototype.hasOwnProperty.call(flagCohorts || {}, flagName)
}

// Cohorts only ever grow, so an empty or missing server value must not shrink what is already known.
export const mergeFlagCohorts = (knownFlagCohorts, incomingFlagCohorts) => {
  const merged = { ...(knownFlagCohorts || {}) }
  Object.entries(incomingFlagCohorts || {}).forEach(([flagName, recordedAt]) => {
    if (!isInFlagCohort(merged, flagName) || (recordedAt && recordedAt < merged[flagName])) {
      merged[flagName] = recordedAt
    }
  })
  return merged
}

export const getFlagsToRecord = ({
  features, flagCohorts, inFlight, rejected = new Set(),
}) => {
  return Object.keys(features || {}).filter((flagName) => (
    !!features[flagName]?.enabled &&
    RECORDABLE_FLAG_NAME.test(flagName) &&
    !isInFlagCohort(flagCohorts, flagName) &&
    !inFlight.has(flagName) &&
    !rejected.has(flagName)
  ))
}

export const chunkFlags = (flagNames, size = FLAG_COHORT_MAX_FLAGS_PER_REQUEST) => {
  const chunks = []
  for (let start = 0; start < flagNames.length; start += size) {
    chunks.push(flagNames.slice(start, start + size))
  }
  return chunks
}

export const withSameUserFlagCohorts = (storedUser, incomingUser) => {
  const knownFlagCohorts = storedUser?.id && storedUser.id === incomingUser?.id
    ? storedUser.flagCohorts
    : null
  if (!knownFlagCohorts && !incomingUser?.flagCohorts) return incomingUser
  return { ...incomingUser, flagCohorts: mergeFlagCohorts(knownFlagCohorts, incomingUser?.flagCohorts) }
}
